import { useEffect } from "react";
import { useLanguage } from "./LanguageContext";
import { getHreflangs } from "./hreflangHelper";

export function useHreflang() {
  const { currentLang } = useLanguage();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const pathname = window.location.pathname;
    const hreflangs = getHreflangs(pathname, currentLang);

    // Remove existing hreflang links
    document.querySelectorAll('link[hreflang]').forEach((el) => el.remove());

    // Inject new hreflang links
    hreflangs.forEach(({ hreflang, href }) => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = hreflang;
      link.href = href;
      document.head.appendChild(link);
    });

    return () => {
      document.querySelectorAll('link[hreflang]').forEach((el) => el.remove());
    };
  }, [currentLang]);
}